import * as React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

function toDatePickerValue(value) {
  if (value == null || value === "") return null;
  if (typeof value?.isValid === "function") {
    return value.isValid() ? value : null;
  }
  const d = dayjs(value);
  return d.isValid() ? d : null;
}

const DatePickerCustom = ({
  label = "",
  value,
  onChange,
  error = false,
  helperText = "",
  height = 53,
  fullWidth = true,
  disabled = false,
  calendarIconColor = "",
  minDate,
  maxDate,
  shouldDisableDate, // Added prop for blocking specific dates
  ...rest
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={toDatePickerValue(value)}
        onChange={onChange}
        disabled={disabled}
        shouldDisableDate={shouldDisableDate} // Passed to MUI DatePicker
        {...(minDate && { minDate })}
        {...(maxDate && { maxDate })}
        slotProps={{
          textField: {
            fullWidth,
            error: Boolean(error),
            helperText: error ? helperText : "",
            InputProps: {
              sx: {
                backgroundColor: "var(--fields-bg)",
                color: "var(--fields-text)",
                height: height,
                borderRadius: "10px",
                "&.Mui-disabled": {
                  backgroundColor: "var(--disabled-bg-color) !important",
                  color: "var(--disabled-text-color) !important",
                  WebkitTextFillColor: "var(--disabled-text-color) !important",
                },
                "&.Mui-disabled .MuiInputBase-input": {
                  color: "var(--disabled-text-color) !important",
                  WebkitTextFillColor: "var(--disabled-text-color) !important",
                },
                "& .MuiInputBase-input": {
                  color: "var(--fields-text)",
                },
                "& .MuiSvgIcon-root": {
                  color: disabled
                    ? "var(--disabled-text-color)"
                    : calendarIconColor || "var(--icon-color)",
                },
              },
            },
            InputLabelProps: {
              sx: {
                color: "var(--label-color)",
              },
            },
            FormHelperTextProps: {
              sx: { marginLeft: 0 },
            },
          },
        }}
        {...rest}
      />
    </LocalizationProvider>
  );
};

export default DatePickerCustom;
